import { Input } from '@lib/components/Input'
import { Button } from '@octopus-do/octopus-storybook'
import { closeModal as closeModalAction } from '@storeOld/reducers/ui'
import type React from 'react'
import { useState } from 'react'
import { useDispatch } from 'react-redux'

import css from './New.module.scss'

type Props = {
  closeButton: React.ReactNode
  input: {
    id: string
    label: string
  }
  onCreate: (name: null | string) => void
  title: string
}

const NewProject: React.FC<Props> = ({
  closeButton,
  onCreate,
  title,
  input,
}) => {
  const dispatch = useDispatch()
  const [projectName, setProjectName] = useState<null | string>(null)

  const onChangeInput = (val: string) => {
    setProjectName(val)
  }

  const closeModal = () => {
    dispatch(closeModalAction())
  }

  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    closeModal()

    onCreate(projectName)
  }

  return (
    <div className={css.modal}>
      <div className={css.heading}>
        <div className={css.title}>{title}</div>

        {closeButton}
      </div>

      <form onSubmit={onSubmit}>
        <div className={css.body}>
          <Input
            autoFocus
            placeholder="Untitled"
            label={input.label}
            id={input.id}
            onChange={onChangeInput}
            type="normal"
          />
        </div>

        <div className={css.footer}>
          <Button type="submit" label="Create" data-testid="create_project" />

          <Button
            priority="secondary"
            label="Cancel"
            data-testid="cancel_project"
            onClick={() => closeModal()}
          />
        </div>
      </form>
    </div>
  )
}

export default NewProject
